export type TourName = "dashboard" | "demandas" | "calendario" | "conteudo" | "clientes";

export interface TourStepDefinition {
  id: string;
  title: string;
  description: string;
  selectors: string[];
  optional?: boolean;
}

export interface TourDefinition {
  name: TourName;
  title: string;
  route: string;
  steps: TourStepDefinition[];
}

export const TOUR_DEFINITIONS: Record<TourName, TourDefinition> = {
  dashboard: {
    name: "dashboard",
    title: "Tour do Dashboard",
    route: "/dashboard",
    steps: [
      {
        id: "metrics",
        title: "Cards de métricas",
        description: "Aqui você vê o resumo da sua operação: clientes ativos, demandas abertas e posts agendados",
        selectors: ['[data-tour-id="dashboard-metrics"]'],
      },
      {
        id: "calendar",
        title: "Calendário da semana",
        description: "Veja todos os posts agendados da semana de um relance",
        selectors: ['[data-tour-id="dashboard-week-calendar"]'],
      },
      {
        id: "new-demand",
        title: "Nova demanda",
        description: "Crie uma nova demanda para sua equipe em poucos cliques",
        selectors: ['[data-tour-id="dashboard-new-demand"]'],
      },
      {
        id: "checklist",
        title: "Checklist de onboarding",
        description: "Complete estes passos para configurar tudo em menos de 5 minutos",
        selectors: ['[data-tour-id="dashboard-onboarding-checklist"]'],
        optional: true,
      },
    ],
  },
  demandas: {
    name: "demandas",
    title: "Tour de Demandas",
    route: "/demandas",
    steps: [
      {
        id: "kanban",
        title: "Colunas do Kanban",
        description: "Cada coluna representa uma etapa do fluxo de trabalho da sua agência",
        selectors: ['[data-tour-id="demands-kanban"]'],
      },
      {
        id: "card",
        title: "Card de demanda",
        description: "Clique em qualquer card para ver detalhes, comentários e histórico",
        selectors: ['[data-tour-id="demand-card"]', '[data-tour-id="demands-kanban"]'],
      },
      {
        id: "new-demand",
        title: "Nova demanda",
        description: "Adicione novas demandas aqui e atribua para sua equipe",
        selectors: ['[data-tour-id="demands-new-demand"]'],
      },
      {
        id: "filters",
        title: "Filtros",
        description: "Filtre demandas por cliente, responsável ou status",
        selectors: ['[data-tour-id="demands-filters"]'],
      },
    ],
  },
  calendario: {
    name: "calendario",
    title: "Tour do Calendário",
    route: "/calendario",
    steps: [
      {
        id: "grid",
        title: "Grade do calendário",
        description: "Visualize todos os posts agendados do mês por cliente",
        selectors: ['[data-tour-id="calendar-grid"]'],
      },
      {
        id: "toolbar",
        title: "Navegação e filtros",
        description: "Navegue entre mês e semana, altere o período e filtre os conteúdos por cliente",
        selectors: ['[data-tour-id="calendar-toolbar"]', '[data-tour-id="calendar-filters"]', '[data-tour-id="calendar-grid"]'],
      },
      {
        id: "new-post",
        title: "Novo post",
        description: "Clique em qualquer dia para criar um post já com a data preenchida",
        selectors: ['[data-tour-id="calendar-new-post"]'],
      },
    ],
  },
  conteudo: {
    name: "conteudo",
    title: "Tour de Conteúdo",
    route: "/conteudo",
    steps: [
      {
        id: "list",
        title: "Lista de conteúdos",
        description: "Gerencie todos os posts da sua agência em um só lugar",
        selectors: ['[data-tour-id="content-list"]'],
      },
      {
        id: "statuses",
        title: "Status dos posts",
        description: "Acompanhe o status de cada post: rascunho, agendado, publicado ou aguardando aprovação",
        selectors: ['[data-tour-id="content-statuses"]'],
      },
      {
        id: "new-content",
        title: "Novo conteúdo",
        description: "Crie posts para Instagram e Facebook e agende a publicação automática",
        selectors: ['[data-tour-id="content-new-button"]'],
      },
    ],
  },
  clientes: {
    name: "clientes",
    title: "Tour de Clientes",
    route: "/clientes",
    steps: [
      {
        id: "list",
        title: "Lista de clientes",
        description: "Cadastre e gerencie todos os clientes da sua agência aqui",
        selectors: ['[data-tour-id="clients-list"]'],
      },
      {
        id: "card",
        title: "Card de cliente",
        description: "Clique em um cliente para ver suas demandas, posts e relatórios",
        selectors: ['[data-tour-id="client-card"]', '[data-tour-id="clients-list"]'],
      },
      {
        id: "new-client",
        title: "Novo cliente",
        description: "Adicione um novo cliente e comece a gerenciar sua operação",
        selectors: ['[data-tour-id="clients-new-button"]'],
      },
    ],
  },
};

export const TOUR_ORDER: TourName[] = ["dashboard", "demandas", "calendario", "conteudo", "clientes"];

export function getTourNameFromPath(pathname: string): TourName | null {
  if (pathname.startsWith("/dashboard")) {
    return "dashboard";
  }

  if (pathname.startsWith("/demandas")) {
    return "demandas";
  }

  if (pathname.startsWith("/calendario")) {
    return "calendario";
  }

  if (pathname.startsWith("/conteudo")) {
    return "conteudo";
  }

  if (pathname.startsWith("/clientes")) {
    return "clientes";
  }

  return null;
}
